export const CheckoutPayment = {
  PAYMENT_FAILED: 'Payment Failed',
  CARD_PROCESSING: 'Processing',
  CARD_SUCCESSFUL: 'Complete Payment',
  CARD_NUM_LABEL: 'Card Number',
  CARD_NAME_LABEL: 'Cardholder name',
};
